import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { map , tap} from 'rxjs/operators';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { DocumentType } from '../entities/documentType';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DocumentTypeService extends BaseCrudService<DocumentType> {

  public uri = '/api/documentType/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance DocumentTypeService');
  }

  buildSentence(entity?: DocumentType, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.name ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
     /* query = query.concat(
        entity.acronym ? 'acronym'
          + QueryOperator.Contain + entity.acronym
          + QueryOperator.Split : QueryOperator.Empty
      );
      if (entity.laborLaw) {
        query = query.concat(
          entity.laborLaw.id ? 'laborLaw.id' + QueryOperator.Equal
            + entity.laborLaw.id + QueryOperator.Split : QueryOperator.Empty
        );
      }
      if (entity.expenseNature) {
        query = query.concat(
          entity.expenseNature.id ? 'expenseNature.id' + QueryOperator.Equal
            + entity.expenseNature.id + QueryOperator.Split : QueryOperator.Empty
        );
      }
      if (entity.generalLedger) {
        query = query.concat(
          entity.generalLedger.id ? 'generalLedger.id' + QueryOperator.Equal
            + entity.generalLedger.id + QueryOperator.Split : QueryOperator.Empty
        );
      }
      */
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }else{ 
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, null);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, null);
    }
    return this.httpParams;
  }


  /** 

  searchToReport(entity?: AbsenceLeave, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<AbsenceLeave>> {

    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<AbsenceLeave>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          } 
          this.spinnerService.hideAll();
          return response;
        })
      );
  }
*/
 
  searchFilters(entity?: DocumentType, event?: LazyLoadEvent, extraQueryCondition?: string[]): Observable<ResponsePageable<DocumentType>> {

    const url = this.rutaServidor + this.uri;
    this.spinnerService.showAll();
    return this.httpClient.get<ResponsePageable<DocumentType>>(url, { params: this.buildSentence(entity, null) })
        .pipe(
            tap(response => {
              let responseFilter : DocumentType[]=[];
                if (response.numberOfElements > 0) {
                    response.content.forEach((value) => {
                        // debugger;
                        this.addLogicToSearch(value);
                        this.convertToDate(value);
                    })
                    for(var i=0; response.content.length>i;i++){
                      for(var j=0; extraQueryCondition.length>j;j++){
                        if(response.content[i].code==extraQueryCondition[j]){
                          responseFilter.push(response.content[i]);
                        } 
                      }
                    } 
                    response.content =responseFilter;
                   //console.log(responseFilter.length);
                    response.numberOfElements = responseFilter.length;
                    response.totalElements = responseFilter.length;
                }
               //console.log(response);
                this.spinnerService.hideAll();
                return response;
            })
        );
}
 

getFiltersOneByCode(code: string | number,extraQueryCondition?: string[]): Observable<DocumentType> {
  // debugger;
  const url = this.rutaServidor + this.uri + 'code/' + code;
  this.spinnerService.showAll();
  let responseFilter : DocumentType[]=[];
  return this.httpClient.get<any>(url)
      .pipe(
          tap((response: ResponsePageable<DocumentType>) => {
            //let responseFilter : DocumentType[]=[];
             //console.log(response);
              // this.addFormat(response);
              if (response.numberOfElements > 0) { 
                    for(var j=0; extraQueryCondition.length>j;j++){
                      if(response.content[0].code==extraQueryCondition[j]){
                        //this.convertToDate(response.content[0]);
                        responseFilter.push(response.content[0])
                      } 
                    }
                  }  
              this.spinnerService.hideAll();
          }),
          map((response: ResponsePageable<DocumentType>) =>responseFilter[0],
           
          this.spinnerService.hideAll())
      );
}

}



// WEBPACK FOOTER //
// ./src/app/core/services/document-type.service.ts